import { AmountUsd } from '@ui/components/Amount/AmountUsd';
import { useTokenDisplayDecimals } from '@ui/hooks/useTokenDisplayDecimals';

import { useEntryPriceAfterSpread } from '../../hooks/useEntryPriceAfterSpread';
import { useTradingPair } from '../../store/useTradingPair';

export const EntryPrice = () => {
  const entryPrice = useEntryPriceAfterSpread();

  const currentTradePairInfo = useTradingPair((s) => s.useTradingPair());
  const priceDisplayDecimals = useTokenDisplayDecimals(
    currentTradePairInfo?.baseSymbol,
    currentTradePairInfo?.priceDisplayDecimals,
  );

  return (
    <AmountUsd
      textAlign="end"
      color="greyWhite.lightGrey1"
      value={entryPrice}
      opts={{
        displayDecimals: priceDisplayDecimals,
      }}
      data-cy="EntryPrice"
      data-cy-value={entryPrice}
    />
  );
};
